import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { DirectivesModule } from "src/app/directives/directives.module";
import { AddressSelectorModule } from "../address-selector/address-selector.module";
import { OptionQuestionComponent } from "../option-question/option-question.component";
import { OtpModule } from "../otp/otp.module";
import { QuestionsModule } from "../questions/questions.module";
import { SharedModule } from "../shared/shared.module";
import { ApgFullQuoteComponent } from "./apg-full-quote.component";
import { BankDetailsModule } from "./bank-details/bank-details-module";
import { CaptureAddressComponent } from "./capture-address/capture-address.component";
import { CompleteQuoteComponent } from "./complete-quote/complete-quote.component";
import { ConfirmQuoteComponent } from "./confirm-quote/confirm-quote.component";
import { DeclarationComponent } from "./declaration/declaration.component";
import { FinalDeclarationComponent } from "./final-declaration/final-declaration.component";
import { MagnumQuestionsComponent } from "./magnum-questions/magnum-questions.component";
import { QuickQuoteSummaryComponent } from "./quick-quote-summary/quick-quote-summary.component";
import { QuoteResultComponent } from "./quote-result/quote-result.component";
import { VerifyQuoteComponent } from "./verify-quote/verify-quote.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DirectivesModule,
    NgxSliderModule,
    CurrencyMaskModule,
    SharedModule,
    QuestionsModule,
    AddressSelectorModule,
    BankDetailsModule,
    OtpModule
  ],
  providers: [
    CurrencyPipe
  ],
  exports: [
    ApgFullQuoteComponent
  ],
  declarations: [
    ApgFullQuoteComponent,
    VerifyQuoteComponent,
    QuickQuoteSummaryComponent,
    CaptureAddressComponent,
    DeclarationComponent,
    MagnumQuestionsComponent,
    QuoteResultComponent,
    FinalDeclarationComponent,
    ConfirmQuoteComponent,
    CompleteQuoteComponent,
    OptionQuestionComponent
  ]
})
export class ApgFullQuoteModule { }

